import { normalizeId } from '@telia-common-components/shared';
import React from 'react';
import { HorizontalFilter, useAnalytics, useCurrentBreakPoint } from 'telia-front-react';
import TvComparisonMobileFilter from './TvComparisonMobileFilter';
const TvComparisonFilter = (props) => {
    const { packageNames, themeNames, appNames, serviceNames, translate, filterState, filterActions, hideApps } = props;
    const currentBreak = useCurrentBreakPoint();
    const { push: pushAnalytics } = useAnalytics();
    const getHorizontalFilterItem = (horizontalFilterItemProps) => {
        const { type, title, allFilters, activeFilters, onActiveFiltersChange } = horizontalFilterItemProps;
        return {
            id: `tv-comparison-filter-${type}`,
            label: title,
            saveButton: { text: translate('tvcomparison.filter.apply'), onClick: () => pushAnalytics(`Apply filter - ${type}`) },
            resetButton: {
                text: translate('tvcomparison.filter.reset'),
                onClick: () => {
                    onActiveFiltersChange([]);
                    pushAnalytics(`Reset filter - ${type}`);
                }
            },
            clearButtonOnClick: () => onActiveFiltersChange([]),
            inputType: {
                choiceGroup: {
                    id: `tv-comparison-filter-choices-${type}`,
                    label: title,
                    type: 'check',
                    hideLabel: true,
                    value: activeFilters.slice(),
                    defaultValue: activeFilters.slice(),
                    onChange: (value) => {
                        onActiveFiltersChange(value);
                        pushAnalytics(`Change filter ${type} - ${value}`);
                    },
                    options: allFilters.map((filterName) => ({
                        id: normalizeId(`tv-comparison-filter-${type}-${filterName}`),
                        labelText: translate(`tvcomparison.filter.${type}.${filterName}`) || filterName,
                        value: filterName
                    }))
                }
            }
        };
    };
    if (currentBreak === 'xs') {
        return React.createElement(TvComparisonMobileFilter, { ...props });
    }
    const getHorizontalFilterItems = () => {
        const horizontalFilterItems = [
            getHorizontalFilterItem({
                type: 'package',
                title: translate('tvcomparison.filter.packages'),
                allFilters: packageNames,
                activeFilters: filterState.selectedPackages,
                onActiveFiltersChange: (activeFilters) => filterActions.setSelectedPackages(activeFilters)
            }),
            getHorizontalFilterItem({
                type: 'theme',
                title: translate('tvcomparison.filter.categories'),
                allFilters: themeNames,
                activeFilters: filterState.selectedThemes,
                onActiveFiltersChange: (activeFilters) => filterActions.setSelectedThemes(activeFilters)
            }),
            getHorizontalFilterItem({
                type: 'service',
                title: translate('tvcomparison.filter.services'),
                allFilters: serviceNames,
                activeFilters: filterState.selectedServices,
                onActiveFiltersChange: (activeFilters) => {
                    filterActions.setSelectedServices(activeFilters);
                }
            })
        ];
        if (!hideApps) {
            horizontalFilterItems.splice(2, 0, getHorizontalFilterItem({
                type: 'app',
                title: translate('tvcomparison.filter.apps'),
                allFilters: appNames,
                activeFilters: filterState.selectedApps,
                onActiveFiltersChange: (activeFilters) => filterActions.setSelectedApps(activeFilters)
            }));
        }
        return horizontalFilterItems;
    };
    return React.createElement(HorizontalFilter, { horizontalFilterItems: getHorizontalFilterItems() });
};
export default TvComparisonFilter;
